import React, { useEffect, useState } from "react";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import GeneralDocumentsGrid from "components/blocks/Grids/GeneralDocumentsGrid";
import NoData from "components/pages/noData/NoData";
import useGetAllGeneralDocument from 'services/management/useGetAllgeneralDocument.ts';

const GeneralDocuments = ({ onCountReady }) => {
  const [generalDocuments, setGeneralDocuments] = useState([]);
  const {
    allGeneralDocuments,
    getAllGeneralDocuments,
    loadingGetAllGeneralDocuments,
  } = useGetAllGeneralDocument();

  useEffect(() => {
    getAllGeneralDocuments(setGeneralDocuments);
  }, []);

  useEffect(() => {
    if (onCountReady && allGeneralDocuments) {
      onCountReady(allGeneralDocuments.length);
    }
  }, [allGeneralDocuments]);

  return (
    <div>
      {loadingGetAllGeneralDocuments && (
        <div className="mgmt-loading"><LoaderMin /></div>
      )}

      {generalDocuments?.length === 0 && !loadingGetAllGeneralDocuments && (
        <NoData message="No hay documentos generales" />
      )}

      {allGeneralDocuments && allGeneralDocuments.length > 0 && (
        <GeneralDocumentsGrid documents={allGeneralDocuments} />
      )}
    </div>
  );
};

export default GeneralDocuments;
